import {
  buildOpenPipelineItems,
  filterOpenPipelineItems,
  type OpenPipelineItem,
} from "@/pages/NewStudio/openPipelineList";
import type { NormalizedJobState } from "@/pages/pipelineHelpers";
import type { JobMetadata, WorkspaceSummary } from "@/types/api";

// The Create pipeline page's list (Figma 14899-267045): every pipeline —
// deployed jobs under their live status, saved workspaces as drafts — the
// Studio's Open-pipeline rows, filtered by name and by status.

export type PipelineStatusFilter = "Running" | "Stopped" | "Failed" | "Draft";

export const STATUS_FILTER_OPTIONS: {
  value: PipelineStatusFilter;
  label: string;
}[] = [
  { value: "Running", label: "Running" },
  { value: "Stopped", label: "Stopped" },
  { value: "Failed", label: "Failed" },
  { value: "Draft", label: "Draft" },
];

/** The filter bucket a row falls in: a converging job counts with the
 *  state it is heading for. */
export function statusOf(item: OpenPipelineItem): PipelineStatusFilter {
  if (item.kind === "draft") return "Draft";
  return SETTLED[item.state];
}

const SETTLED: Record<NormalizedJobState, PipelineStatusFilter> = {
  Running: "Running",
  Starting: "Running",
  Stopped: "Stopped",
  Stopping: "Stopped",
  Failed: "Failed",
};

/** The rows the filters let through, sorted by name; an empty status
 *  selection matches everything. */
export function visiblePipelineItems(
  workspaces: ReadonlyArray<WorkspaceSummary>,
  jobs: ReadonlyArray<JobMetadata>,
  filters: { name: string; statuses: ReadonlyArray<PipelineStatusFilter> },
): OpenPipelineItem[] {
  const byName = filterOpenPipelineItems(
    buildOpenPipelineItems([...workspaces], [...jobs]),
    filters.name,
  );
  if (filters.statuses.length === 0) return byName;
  return byName.filter((item) => filters.statuses.includes(statusOf(item)));
}
